export default __webpack_public_path__ + "1953033104ad28e9f8c70df9c38285f1.png";